import { useState } from 'react';
import { useSystemGuardrails, useCustomGuardrails } from '@/hooks';
import { GuardrailCard } from '@/modules/guardrails';
import { Skeleton } from '@/components/ui/skeleton';
import { SearchInput } from '@/components/ui/input';

export default function Guardrails() {
  const { data: systemGuardrails = [], isLoading: systemLoading, error: systemError } = useSystemGuardrails();
  const { data: customGuardrails = [], isLoading: customLoading, error: customError } = useCustomGuardrails();
  const [search, setSearch] = useState('');

  const allGuardrails = [...systemGuardrails, ...customGuardrails].filter((g) =>
    g.name.toLowerCase().includes(search.toLowerCase())
  );

  const isLoading = systemLoading || customLoading;
  const error = systemError || customError;

  if (error) {
    return (
      <div className='flex gap-8 flex-col p-4'>
        <div className='flex justify-between items-start'>
          <h1 className='text-base font-semibold'>Guardrails</h1>
        </div>
        <div className='text-sm text-destructive'>Failed to load guardrails. Please try again later.</div>
      </div>
    );
  }

  return (
    <div className='flex gap-6 flex-col p-4'>
      <div className='flex justify-between items-start'>
        <h1 className='text-base font-semibold'>Guardrails</h1>
        <SearchInput placeholder='Search guardrails...' value={search} onChange={(e) => setSearch(e.target.value)} />
      </div>

      {isLoading ? (
        <div className='grid grid-cols-3 gap-4'>
          {Array.from({ length: 9 }).map((_, i) => (
            <div key={i} className='flex flex-col gap-6 p-6 border rounded-xl'>
              <Skeleton className='h-4 w-32' />
              <Skeleton className='h-16 w-full' />
              <Skeleton className='h-8 w-16' />
            </div>
          ))}
        </div>
      ) : (
        <div className='grid grid-cols-3 gap-4'>
          {allGuardrails.map((guardrail) => (
            <GuardrailCard key={guardrail.id} guardrail={guardrail} />
          ))}
        </div>
      )}
    </div>
  );
}
